import "../base";
const items = document.querySelectorAll(".item");

items.forEach(item => {
  const control = item.querySelector(".control");
  const answer = item.querySelector(".answer");

  control.addEventListener("click", () => {
    const status = control.dataset.expanded;
    control.dataset.expanded = status === "0" ? "1" : "0";
    answer.dataset.expanded = status === "0" ? "1" : "0";
  });
});
